import React , {Component} from 'react';

export default class ConfirmationModal extends Component{
    // constructor(){
    //     super()
    // }

    render(){
       if(this.props.isModalOpen === true){
           return(
            <div class="modal" style={{display:'block'}} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
            <div class="modal-dialog event-confirmation-modal" role="document">
              <div class="modal-content">
              <div className="event-confirm-main-div">
              <div class="form-back-link" onClick={() => this.props.HideConfirmationModal()}>
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                  <a>Back</a>
              </div>

              <div className="container">
              <div className="event-confirm-head">
              <h3>Session Booking Confirmation</h3>
              </div>
              <div class="event-confirm-info">
              <div class="row">
              <div class="col-md-12 col-lg-12">
              <p>You have successfully registered for this free session</p>
              <p>You should recieve an email shortly with confirmation of your registration and details of how to join the session.</p>
              <p>Be sure to check your spam/junk folders if you don't find anything in your inbox from us.</p>
              <p>Please <span class="bold-words">don't share your</span> Zoom link with anyone as it could adversely affect the quality of broadcast for all attendees.</p>
              <p>If you would like to share this session with others, you can direct them to our upcoming sessions page to book a free ticket for themselves.</p>
              <p>Many Thanks!</p>
              <span class="bold-words">Team Kinship</span>
              </div>
              
              </div>
              
              </div>
              </div>
          </div>
               
                <div class="modal-footer">
                  <button type="button" class="btn confirmation-back-btn" data-dismiss="modal"
                  onClick={() => this.props.HideConfirmationModal()}
                  >Back to List</button>
                  
                </div>
              </div>
            </div>
          </div>
           )
       }
       else return null
    }
}